import { setAppSpinning, showNotification } from 'app/appSlice'
import CancelInvoiceModal from 'general/components/Modal/CancelInvoiceModal'
// import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import { List, Space, Tooltip } from 'antd'
import invoiceApi from 'api/invoiceApi'
import dayjs from 'dayjs'
import {
  setClearRows,
  setModalsState,
  setSelectedInvoices,
} from 'features/Invoice/invoiceSlice'
import ModalConvertPaper from 'features/Search/components/ModalConvertPaper'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import ExplanationInvoiceModal from 'general/components/Modal/ExplanationInvoiceModal'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ModalSelectAdjustInvoiceMethod from 'general/components/Modal/ModalSelectAdjustInvoiceMethod'
import ModalSendEmail from 'general/components/Modal/ModalSendEmail'
import ModalUnauthorized from 'general/components/Modal/ModalUnauthorized'
import ModalUploadInvoiceExcel from 'general/components/Modal/ModalUploadInvoiceExcel'
import SendInvoiceModal from 'general/components/Modal/SendInvoiceModal'
import ModalDataTransmissionLog from 'general/components/ModalDataTransmissionLog'
import {
  INVOICE_STATUS,
  INVOICE_TYPE,
  MESSAGE_SUCCESS,
} from 'general/constants/AppConstants'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import SelectOptions from 'general/constants/SelectOptions'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import ToastHelper from 'general/helpers/ToastHelper'
import Utils, { getYearsFromDates, padNumber } from 'general/utils/Utils'
import useGetSerials from 'hooks/Queries/useGetSerials'
import useAppDnD from 'hooks/useAppDnD'
import useFilter from 'hooks/useFilter'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import useSearchDebounce from 'hooks/useSearchDebounce'
import _ from 'lodash'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'
import { useQueryListInInvoice } from '../../../Invoice/screens/ListInvoice/queries'
import './style.scss'
import { useQuery } from '@tanstack/react-query'
import { goodsQueries } from 'features/Category/screens/GoodsScreen/queries'
import ModalSelectReplaceInvoiceMethod from 'general/components/Modal/ModalSelectReplaceInvoiceMethod'
import InvoiceDashboard from 'features/Invoice/screens/ListInvoice/Components/InvoiceDashboard'
import VIElements from './Components/VIElements'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import AppResource from 'general/constants/AppResource'
import {
  thunkCheckExistAccount,
  thunkCreataAccountService,
  thunkGetProfile,
  thunkSynchronizationCQT,
} from 'features/InPutEInvoice/inputEinvoiceSlice'
import VIModal from '../ConnectTax/Components/VIModal'
import ViewChooseDateRangeSync from './Components/ViewChooseDateRangeSync'
import VIButton from 'general/components/eInvoiceComponents/VIButton'
import Global from 'general/utils/Global'
import ViewInvoiceExport from './Components/ViewInvoiceExport'

function ListInInvoice() {
  // MARK --- Parmas: ---
  const { t } = useTranslation()
  const { navigate } = useRouter()
  const dispatch = useAppDispatch()

  const { selectedInvoices, toggledClearRows, modalStates } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )

  const [filterParams, setFilterParams] = useFilter('gFiltersInputInvoice')
  const [dateSerial, setDateSerial] = useState([])
  const [modalChooseDateRangeSyncShowing, setModalChooseDateRangeSyncShowing] =
    useState(false)
  const [modalViewPDF, setModalViewPDF] = useState(false)
  const [dataActive, setDataActive] = useState({})

  const [inforSys, setInforSys] = useState(false)
  const [isSynchronizing, setIsSynchronizing] = useState()
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const [goodsFilterParams] = useState({
    status: 'ACTIVE',
    page: 0,
    limit: 50,
  })
  const [profile, setProfile] = useState({})
  const [exitsAccount, setExitsAccount] = useState({
    show: false,
    disable: true,
  })
  //#region --- Queries, Mutate ---

  const {
    invoiceListData,
    isGettingListData,
    isRefetching,
    refetchListInvoice,
  } = useQueryListInInvoice(debouncedSearch, { ...filterParams, optimize: 1 })

  const { data: goodsOption } = useQuery({
    ...goodsQueries.listOfGoods(goodsFilterParams),
    select: (res) => {
      return _.concat(
        { value: null, label: 'Tất cả hàng hóa' },
        res?.goods,
      ).map((v) => ({
        label: v.label ?? v.name,
        value: v.name ?? v.value,
      }))
    },
  })

  const [modalInvoiceExportShowing, setModalInvoiceExportShowing] =
    useState(false)

  const defaultValues = useMemo(() => {
    /** @type {Array<FilterDefaultValueProp>} */
    const arr = [
      {
        label: 'Theo ngày',
        alias: 'Theo ngày',
        formName: 'dateType',
        options: SelectOptions.dataStatusDateType,
        value: SelectOptions.dataStatusDateType[0].value,
      },
      {
        label: 'Tình trạng hạch toán',
        alias: 'Tình trạng hạch toán',
        formName: 'dateAccounting',
        options: SelectOptions.dataAccounTingStatus,
        value: SelectOptions.dataAccounTingStatus[0].value,
      },
      {
        label: 'Tình trạng hoá đơn',
        alias: 'Tình trạng hoá đơn',
        formName: 'status',
        options: SelectOptions.dataStatusInvoice,
        value: SelectOptions.dataStatusInvoice[0].value,
      },
      {
        label: 'Nhãn',
        alias: 'Nhãn',
        formName: 'tagId',
        options: SelectOptions.dataSticker,
        value: SelectOptions.dataSticker[0].value,
      },
      {
        label: 'Nguồn hóa đơn',
        alias: 'Nguồn hóa đơn',
        formName: 'typeInvoiceReceive',
        options: SelectOptions.dataInvoiceSource,
        value: SelectOptions.dataInvoiceSource[0].value,
      },
      {
        label: 'Trạng thái',
        alias: 'Trạng thái',
        formName: 'statusInvoice',
        options: SelectOptions.hd_status,
        value: SelectOptions.hd_status[0].value,
      },
      {
        label: 'Mẫu hóa đơn',
        alias: 'Mẫu hóa đơn',
        formName: 'invoiceTypeCode',
        options: SelectOptions.TypeCode,
        value: SelectOptions.TypeCode[0].value,
      },
      {
        label: 'Hình thức hóa đơn',
        alias: 'Hình thức hóa đơn',
        formName: 'invoiceSerialType',
        options: SelectOptions.serial,
        value: SelectOptions.serial[0].value,
      },
    ]
    return arr
  }, [goodsOption])

  const getInvoiceStatusPayment = (type) => {
    switch (type) {
      case 'Chưa thanh toán':
        return (
          <VIElements
            id={'2'}
            text={type}
            style={{
              // color: '#212121',
              background: '#F3F4F7',
              padding: '4px 8px',
              border: 'none',
            }}
          />
        )
      case 'Thanh toán một phần':
        return (
          <VIElements
            id={'3'}
            text={type}
            style={{
              color: '#E18700',
              background: 'rgba(213, 133, 59, 0.10)',
              padding: '4px 8px',
              border: 'none',
            }}
          />
        )
      case 'Thanh toán toàn phần':
        return (
          <VIElements
            id={'4'}
            text={type}
            style={{
              color: '#20A144',
              background: 'rgba(40, 160, 67, 0.1)',
              padding: '4px 8px',
              border: 'none',
            }}
          />
        )
      case 'Đến hạn thanh toán':
        return (
          <VIElements
            id={'5'}
            text={type}
            style={{
              color: '#E18700',
              background: 'rgba(213, 133, 59, 0.10)',
              padding: '4px 8px',
              border: 'none',
            }}
          />
        )
      case 'Quá hạn thanh toán':
        return (
          <VIElements
            id={'6'}
            text={type}
            style={{
              color: '#FF6666',
              background: '#FF2F0033',
              padding: '4px 8px',
              border: 'none',
            }}
          />
        )
      default:
        return (
          <VIElements
            id={'6'}
            text="Không có trạng thái"
            style={{
              background: 'transparent',
              padding: '4px 8px',
              border: 'none',
            }}
          />
        )
    }
  }

  const getInvoiceStatusValidate = (type, code, manual, invoice) => {
    if (!type) {
      return (
        <VIElements
          id={'1'}
          text="Chưa kiểm tra"
          style={{
            // color: '#212121',
            background: '#F3F4F7',
            padding: '4px 8px',
            border: 'none',
          }}
        />
      )
    }
    if (
      type?.checkResultBuyerAddress &&
      type?.checkResultBuyerName &&
      type?.checkResultBuyerTaxCode &&
      type?.checkResultHasCQTRecord &&
      type?.checkResultHasInvoiceCode &&
      type?.checkResultSellerAddress &&
      type?.checkResultSellerName &&
      type?.checkResultSignatureCQT &&
      type?.checkResultSignatureNCC &&
      type?.checkResultSellerTaxCode
    ) {
      return (
        <VIElements
          id={'2'}
          text="Hóa đơn hợp lệ"
          icon={
            <i
              className="fa-regular fa-circle-check"
              style={{ color: '#20A144' }}
            ></i>
          }
          style={{
            color: '#20A144',
            background: 'rgba(40, 160, 67, 0.1)',
            padding: '4px 8px',
            border: 'none',
          }}
        />
      )
    }

    let dataValidate = []
    if (type?.checkResultBuyerName === false) {
      dataValidate.push({
        name: 'Sai tên người mua',
        id: 4,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultBuyerAddress === false) {
      dataValidate.push({
        name: 'Sai địa chỉ người mua',
        id: 5,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultBuyerTaxCode === false) {
      dataValidate.push({
        name: 'Sai mã số thuế người mua',
        id: 6,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (!type?.checkResultHasCQTRecord && !manual) {
      dataValidate.push({
        name: 'Hóa đơn chưa tồn tại',
        id: 7,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (!type?.checkResultHasInvoiceCode && !code?.startsWith('K') && !manual) {
      dataValidate.push({
        name: 'Chưa có mã hóa đơn',
        id: 8,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultSellerTaxCode === false) {
      dataValidate.push({
        name: 'Sai mã số thuế người bán',
        id: 9,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultSellerAddress === false) {
      dataValidate.push({
        name: 'Sai địa chỉ người bán',
        id: 9,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultSellerName === false) {
      dataValidate.push({
        name: 'Sai tên người bán',
        id: 10,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (
      type?.checkResultSignatureCQT === false &&
      !code?.startsWith('K') &&
      invoice.cqtCKS
    ) {
      dataValidate.push({
        name: 'Sai chữ ký cơ quan thuế',
        id: 10,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultSignatureNCC === false && invoice.sellerCKS) {
      dataValidate.push({
        name: 'Sai chữ ký nhà cung cấp',
        id: 11,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.checkResultBuyerName === null) {
      dataValidate.push({
        name: 'Không có tên người mua',
        id: 12,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.checkResultBuyerAddress === null) {
      dataValidate.push({
        name: 'Không có địa chỉ người mua',
        id: 13,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.checkResultBuyerTaxCode === null) {
      dataValidate.push({
        name: 'Không có mã số thuế người mua',
        id: 14,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.checkResultSellerAddress === null) {
      dataValidate.push({
        name: 'Không có địa chỉ người bán',
        id: 15,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.checkResultSellerTaxCode === null) {
      dataValidate.push({
        name: 'Không có mã số thuế người bán',
        id: 15,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.checkResultSellerName === null) {
      dataValidate.push({
        name: 'Không có tên người bán',
        id: 16,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (!invoice.sellerCKS && !manual) {
      dataValidate.push({
        name: 'Không có chữ ký nhà cung cấp',
        id: 17,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.nb_khong_rui_ro_tai_tdlap === null && manual) {
      dataValidate.push({
        name: 'Không kiểm tra được trạng thái người bán',
        id: 18,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.mauso_kyhieu_da_tb === null && manual) {
      dataValidate.push({
        name: 'Không kiểm tra được mẫu số kí hiệu',
        id: 19,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.so_hd_thuoc_khoang_phat_hanh === null && manual) {
      dataValidate.push({
        name: 'Không kiểm tra được số hóa đơn',
        id: 20,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.ngay_hoa_don_tu_ngay_su_dung === null && manual) {
      dataValidate.push({
        name: 'Không kiểm tra được ngày hóa đơn',
        id: 21,
        icon: (
          <i
            className="fa-regular fa-hexagon-exclamation"
            style={{ color: '#E18700' }}
          ></i>
        ),
        color: '#E18700',
        background: 'rgba(213, 133, 59, 0.10)',
      })
    }
    if (type?.nb_khong_rui_ro_tai_tdlap === false && manual) {
      dataValidate.push({
        name: 'Người bán thuộc cảnh báo của tổng cục thuế',
        id: 22,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.mauso_kyhieu_da_tb === false && manual) {
      dataValidate.push({
        name: 'Mẫu số ký hiệu chưa được thông báo phát hành',
        id: 23,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.so_hd_thuoc_khoang_phat_hanh === false && manual) {
      dataValidate.push({
        name: 'Số hóa đơn không thuộc thông báo phát hành',
        id: 24,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (type?.ngay_hoa_don_tu_ngay_su_dung === false && manual) {
      dataValidate.push({
        name: 'Ngày hóa đơn nhỏ hơn ngày bắt đầu sử dụng',
        id: 25,
        icon: (
          <i
            className="fa-regular fa-circle-xmark"
            style={{ color: '#EE2334' }}
          ></i>
        ),
        color: '#EE2334',
        background: 'rgba(255, 87, 87, 0.10)',
      })
    }
    if (dataValidate?.length > 0) {
      return dataValidate.map((item, index) => (
        <VIElements
          icon={item?.icon}
          key={index}
          id={item?.id}
          text={item?.name}
          style={{
            color: item?.color,
            background: item?.background,
            padding: '3px 5px',
            border: 'none',
            marginTop: '2px',
          }}
        />
      ))
    }
  }

  const defaultColumns = useMemo(
    () => [
      {
        name: t('Label'),
        width: '80px',
        center: true,
        cell: (row) => {
          return (
            <div className="d-flex align-items-center mb-1">
              {row?.Tags?.length === 1 ? (
                <KTTooltip
                  text={
                    <div>
                      {row?.Tags?.map((e, index) => (
                        <div key={index}>{e?.name}</div>
                      ))}
                    </div>
                  }
                  position={'auto'}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="12"
                    viewBox="0 0 18 14"
                    fill="none"
                    onClick={() => {
                      // setShowModalLabeled(true), setListCurrentLabels(row?.Tags)
                      // setDataCurrentAddLabel([row])
                    }}
                  >
                    <path
                      d="M0 1C0 0.447716 0.447715 0 1 0H12.6706C13.0002 0 13.3086 0.162442 13.4951 0.434246L17.6118 6.43425C17.8457 6.77515 17.8457 7.22485 17.6118 7.56575L13.4951 13.5658C13.3086 13.8376 13.0002 14 12.6706 14H1C0.447716 14 0 13.5523 0 13V1Z"
                      fill={row?.Tags?.[0]?.color}
                    />
                  </svg>
                </KTTooltip>
              ) : row?.Tags?.length > 1 ? (
                <KTTooltip
                  text={
                    <div>
                      {row?.Tags?.map((e, index) => (
                        <div key={index}>{e?.name}</div>
                      ))}
                    </div>
                  }
                  position={'auto'}
                >
                  <div
                    className="p-2"
                    onClick={() => {
                      // setShowModalLabeled(true), setListCurrentLabels(row?.Tags)
                      // setDataCurrentAddLabel([row])
                    }}
                  >
                    <img
                      style={{ height: '12px' }}
                      src={AppResource.icons.icTags}
                    />
                  </div>
                </KTTooltip>
              ) : (
                <KTTooltip text={t('Stickers')} position={'auto'}>
                  <div
                    className="p-2"
                    onClick={() => {
                      // setShowModalLabeled(true)
                      // setDataCurrentAddLabel([row])
                    }}
                  >
                    <img
                      style={{ height: '12px' }}
                      src={AppResource.icons.icLabelVietInvoice}
                    />
                  </div>
                </KTTooltip>
              )}
            </div>
          )
        },
      },
      {
        name: t('InvoiceNumber'),
        minWidth: '135px',
        selector: (row) => row.invoiceNumber,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.invoiceNumber ? row?.invoiceNumber : ''}
            </p>
          )
        },
      },
      {
        name: t('Denominator'),
        width: '98px',
        selector: (row) => row.invoiceTypeCode,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.invoiceTypeCode ? row?.invoiceTypeCode : ''}
            </p>
          )
        },
      },
      {
        name: t('Symbol'),
        width: '100px',
        selector: (row) => row.serial,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.serial ? row?.serial : ''}
            </p>
          )
        },
      },
      {
        name: t('InvoiceDate'),
        width: '150px',
        selector: (row) => row.invoiceDate,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.invoiceDate
                ? Utils.formatDateTime(row?.invoiceDate, 'DD/MM/yyyy' ?? '')
                : ''}
            </p>
          )
        },
      },
      {
        name: t('SignDate'),
        width: '115px',
        selector: (row) => row.signDate,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.signDate
                ? Utils.formatDateTime(row?.signDate, 'DD/MM/yyyy')
                : ''}
            </p>
          )
        },
      },
      {
        name: t('CodeIssueDate'),
        width: '145px',
        selector: (row) => row.providedCodeDate,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.providedCodeDate
                ? Utils.formatDateTime(row?.providedCodeDate, 'DD/MM/yyyy')
                : ''}
            </p>
          )
        },
      },
      {
        name: t('UnitCode'),
        width: '120px',
        selector: (row) => row.sellerCode,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.sellerCode ? row?.sellerCode : ''}
            </p>
          )
        },
      },
      {
        name: t('SellerTaxCode'),
        width: '200px',
        selector: (row) => row.sellerTaxCode,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.sellerTaxCode ? row?.sellerTaxCode : ''}
            </p>
          )
        },
      },
      {
        name: t('SellerInformations'),
        minWidth: '250px',
        selector: (row) => row.sellerName,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.sellerName ? row?.sellerName : ''}
            </p>
          )
        },
      },
      {
        name: t('SellerAddress'),
        minWidth: '250px',
        selector: (row) => row.sellerAddress,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.sellerAddress ? row?.sellerAddress : ''}
            </p>
          )
        },
      },
      {
        name: t('TotalPreTaxMoney'),
        minWidth: '215px',
        selector: (row) => row.amountBeforeVat,
        sortable: true,
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 text-align-end"
            >
              {row?.amountBeforeVat
                ? Utils.formatCurrency(row?.amountBeforeVat)
                : row?.amountBeforeVat}
            </p>
          )
        },
      },
      {
        name: t('taxMoney'),
        minWidth: '117px',
        selector: (row) => row.amountVat,
        sortable: true,
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 text-align-end"
            >
              {row?.amountVat
                ? Utils.formatCurrency(row?.amountVat)
                : row?.amountVat}
            </p>
          )
        },
      },
      {
        name: t('TotalPaymentHDDV'),
        minWidth: '215px',
        selector: (row) => row.finalAmount,
        sortable: true,
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 text-align-end"
            >
              {row?.finalAmount
                ? Utils.formatCurrency(row?.finalAmount)
                : row?.finalAmount}
            </p>
          )
        },
      },
      {
        name: t('Currency'),
        selector: (row) => row.paymentCurrency,
        sortable: true,
        minWidth: '113px',

        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.paymentCurrency ? row?.paymentCurrency : ''}
            </p>
          )
        },
      },
      {
        name: t('ExchangeRate'),
        selector: (row) => row.paymentExchangeRate,
        sortable: true,
        width: '90px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.paymentExchangeRate ? row?.paymentExchangeRate : ''}
            </p>
          )
        },
      },
      {
        name: t('TotalAmountConverted'),
        width: '182px',
        selector: (row) => row.finalAmountExchange,
        sortable: true,
        right: true,
        cell: (row) => {
          return (
            <p className="font-weight-normal m-0 text-maxline-3 text-align-end">
              {row?.finalAmountExchange
                ? Utils.formatNumber(row?.finalAmountExchange)
                : ''}
            </p>
          )
        },
      },
      {
        name: t('invoiceStatus'),
        width: '200px',
        selector: (row) => row.statusInvoiceText,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.statusInvoiceText ? row?.statusInvoiceText : ''}
            </p>
          )
        },
      },
      {
        name: t('InvoiceAdjusted/Replaced'),
        minWidth: '290px',

        cell: (row) => {
          return row?.statusInvoiceText === 'Hoá đơn thay thế' ? (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {`Thay thế cho hóa đơn ký hiệu ${
                row?.hdgocData?.khmshdon ? row?.hdgocData?.khmshdon : ''
              }${row?.hdgocData?.khhdon ? row?.hdgocData?.khhdon : ''}, số ${
                row?.hdgocData?.shdon ? row?.hdgocData?.shdon : ''
              }, ngày ${
                row?.hdgocData?.tdlap
                  ? Utils.formatDateTime(
                      row?.hdgocData?.tdlap,
                      'DD/MM/yyyy' ?? '',
                    )
                  : ''
              }`}
            </p>
          ) : row?.statusInvoiceText === 'Hoá đơn điều chỉnh' ? (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {`Điều chỉnh cho hóa đơn ký hiệu ${
                row?.hdgocData?.khmshdon ? row?.hdgocData?.khmshdon : ''
              }${row?.hdgocData?.khhdon ? row?.hdgocData?.khhdon : ''}, số ${
                row?.hdgocData?.shdon ? row?.hdgocData?.shdon : ''
              }, ngày ${
                row?.hdgocData?.tdlap
                  ? Utils.formatDateTime(
                      row?.hdgocData?.tdlap,
                      'DD/MM/yyyy' ?? '',
                    )
                  : ''
              }`}
            </p>
          ) : (
            ''
          )
        },
      },
      // {
      //   name: t('TestResults'),
      //   width: '320px',

      //   cell: (row) => {
      //     return (
      //       <div data-tag="allowRowEvents">
      //         {getInvoiceStatusValidate(
      //           row?.InvoiceValidate,
      //           row?.serial,
      //           row?.isManualInput,
      //           row,
      //         )}
      //       </div>
      //     )
      //   },
      // },
      {
        name: t('CheckTaxRates'),
        minWidth: '195px',
        selector: (row) => row.statusTax,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 text-align-end"
            >
              {row?.statusTax ?? ''}
            </p>
          )
        },
      },
      // {
      //   name: t('EmailToReceiveInvoice'),
      //   minWidth: '190px',
      //   cell: (row) => {
      //     return (
      //       <p
      //         data-tag="allowRowEvents"
      //         className=" font-weight-normal m-0 text-maxline-3 mr-4"
      //       >
      //         {/* {store.getState()?.auth.account?.OrganizationDepartment
      //           ? store.getState()?.auth.account?.OrganizationDepartment
      //               ?.invoiceMailbox
      //           : (store.getState()?.auth.account?.Organization
      //               ?.invoiceMailbox ?? '')} */}
      //       </p>
      //     )
      //   },
      // },
      {
        name: t('EmailSendingStatus'),
        width: '190px',
        // center: true,
        // selector: (row) => row.statusEmail,
        // sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.isSendMailSupplier ? 'Đã gửi' : ''}
            </p>
          )
        },
      },
      {
        name: t('LookUpOriginalInvoice'),
        width: '200px',
        center: true,

        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 "
              style={{ width: '100%' }}
            >
              <span
                className="d-flex align-items-center py-5 px-4"
                style={{ color: '#22C55E' }}
                onClick={() => {
                  // setCurrentInvoices(row), setModalLookUpInvoice(true)
                }}
              >
                <i
                  className="fa-regular fa-lightbulb-on me-1"
                  style={{ color: '#22C55E' }}
                ></i>
                Thông tin tra cứu
              </span>
            </p>
          )
        },
      },
      {
        name: t('PaymentDueDate'),
        width: '185px',
        selector: (row) => row.reminderPaymentDate,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.reminderPaymentDate
                ? Utils.formatDateTime(row?.reminderPaymentDate, 'DD/MM/YYYY')
                : ''}
            </p>
          )
        },
      },
      {
        name: t('PaymentTerm'),
        width: '168px',
        selector: (row) => row.expiredPaymentDate,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.expiredPaymentDate
                ? Utils.formatDateTime(row?.expiredPaymentDate, 'DD/MM/YYYY')
                : ''}
            </p>
          )
        },
      },
      // {
      //   name: t('TaxCodeCompany'),
      //   minWidth: '130px',
      //   cell: (row) => {
      //     return (
      //       <p
      //         data-tag="allowRowEvents"
      //         className=" font-weight-normal m-0 text-maxline-3 mr-4"
      //       >
      //         {/* {store.getState()?.auth.account?.Organization?.OrganizationHQ
      //           ? store.getState()?.auth.account?.Organization?.OrganizationHQ
      //               ?.taxCode
      //           : (store.getState()?.auth.account?.Organization?.taxCode ?? '')} */}
      //       </p>
      //     )
      //   },
      // },
      // {
      //   name: t('Company'),
      //   minWidth: '250px',
      //   cell: (row) => {
      //     return (
      //       <p
      //         data-tag="allowRowEvents"
      //         className=" font-weight-normal m-0 text-maxline-3 mr-4"
      //       >
      //         {/* {store.getState()?.auth.account?.Organization?.OrganizationHQ
      //           ? store.getState()?.auth.account?.Organization?.OrganizationHQ
      //               ?.organizationName
      //           : (store.getState()?.auth.account?.Organization
      //               ?.organizationName ?? '')} */}
      //       </p>
      //     )
      //   },
      // },
      // {
      //   name: t('TaxCodeBrand'),
      //   minWidth: '150px',
      //   cell: (row) => {
      //     return (
      //       <p
      //         data-tag="allowRowEvents"
      //         className=" font-weight-normal m-0 text-maxline-3 mr-4"
      //       >
      //         {/* {store.getState()?.auth.account?.Organization
      //           ?.organizationType === 'BRANCH'
      //           ? store.getState()?.auth.account?.Organization?.taxCode
      //           : ('' ?? '')} */}
      //       </p>
      //     )
      //   },
      // },
      // {
      //   name: t('Branch'),
      //   minWidth: '250px',
      //   // selector: (row) => row.supplier,
      //   // sortable: true,
      //   cell: (row) => {
      //     return (
      //       <p
      //         data-tag="allowRowEvents"
      //         className=" font-weight-normal m-0 text-maxline-3 mr-4"
      //       >
      //         {/* {store.getState()?.auth.account?.Organization
      //           ?.organizationType === 'BRANCH'
      //           ? store.getState()?.auth.account?.Organization?.organizationName
      //           : ('' ?? '')} */}
      //       </p>
      //     )
      //   },
      // },
      {
        name: t('PurchaserName'),
        minWidth: '250px',
        selector: (row) => row.buyerName,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.buyerName ? row?.buyerName : ''}
            </p>
          )
        },
      },
      {
        name: t('BuyerAddress'),
        minWidth: '250px',
        selector: (row) => row.buyerAddress,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.buyerAddress ? row?.buyerAddress : ''}
            </p>
          )
        },
      },
      {
        name: t('Buyer'),
        minWidth: '200px',
        selector: (row) => row.buyerPersonName,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.buyerPersonName ? row?.buyerPersonName : ''}
            </p>
          )
        },
      },
      // {
      //   name: t('Department'),
      //   minWidth: '250px',
      //   // selector: (row) => row.supplier,
      //   // sortable: true,
      //   cell: (row) => {
      //     return (
      //       <p
      //         data-tag="allowRowEvents"
      //         className=" font-weight-normal m-0 text-maxline-3 mr-4"
      //       >
      //         {/* {store.getState()?.auth.account?.OrganizationDepartment
      //           ?.departmentName ?? ''} */}
      //       </p>
      //     )
      //   },
      // },
      {
        name: t('InvoiceReceiptDate'),
        minWidth: '195px',
        selector: (row) => row.invoiceReceiveDate,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 mr-4"
            >
              {row?.invoiceReceiveDate
                ? Utils.formatDateTime(row.invoiceReceiveDate, 'DD/MM/YYYY')
                : ''}
            </p>
          )
        },
      },

      {
        name: t('TotalPaymentSuccess'),
        minWidth: '225px',
        // selector: (row) => row.amountBeforeVat,
        // sortable: true,
        right: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 text-align-end"
            >
              {row?.debtPayment
                ? Utils.formatCurrency(row?.finalAmount - row.debtPayment)
                : ''}
            </p>
          )
        },
      },
      {
        name: t('UnpaidMoney'),
        minWidth: '215px',
        right: true,
        selector: (row) => row.debtPayment,
        sortable: true,
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className=" font-weight-normal m-0 text-maxline-3 text-align-end"
            >
              {row?.debtPayment ? Utils.formatCurrency(row?.debtPayment) : ''}
            </p>
          )
        },
      },
      {
        name: t('PaymentStatus'),
        width: '230px',
        center: true,
        selector: (row) => row.statusPayment,
        sortable: true,
        cell: (row) => {
          return (
            <div data-tag="allowRowEvents">
              {getInvoiceStatusPayment(row?.statusPayment)}
            </div>
          )
        },
      },
      {
        name: 'Hành động',
        center: true,
        width: '100px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedf3',
        },
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-between">
            <TableAction
              titleActionText="Xem"
              icon={<IconAction className="fa-light fa-eye" />}
              onClick={() => {
                setModalViewPDF(true)
                setDataActive(row)
              }}
            />
            {/* <VITableRowDropDown
              toggleElement={
                <div>
                  <i className="text-grey fas fa-ellipsis-h p-0"></i>
                </div>
              }
              menuItem={handleActions(row)}
            /> */}
          </div>
        ),
      },
    ],
    [dispatch, navigate, t],
  )

  const dynamicColumns = useAppDnD(defaultColumns)

  const getProfile = async () => {
    const data = await dispatch(thunkGetProfile())
    console.log('data', data?.payload?.account)
    setProfile(data?.payload?.account ?? {})
  }

  const synchronizationCQT = async (body) => {
    const data = await dispatch(thunkSynchronizationCQT(body))
    if (!data?.error) {
      ToastHelper.showSuccess('Đang đồng bộ dữ liệu')
      getProfile()
      setInforSys(true)
      closeInforSys()
    }
    console.log('data', data)
  }

  const creataAccountService = async (body) => {
    const data = await dispatch(thunkCreataAccountService(body))
    // if (!data?.error) {
    //   ToastHelper.showSuccess('Đang đồng bộ dữ liệu')
    //   getProfile()
    //   setInforSys(true)
    //   closeInforSys()
    // }
    if (data?.payload?.result == 'success') {
      ToastHelper.showSuccess('Đăng ký dịch vụ hóa đơn đầu vào thành công')
      checkExistAccount()
    } else {
      ToastHelper.showSuccess(data?.payload?.error)
    }
  }

  const checkExistAccount = async () => {
    const data = await dispatch(thunkCheckExistAccount())
    if (data?.payload?.exist === false) {
      setExitsAccount({ show: true, disable: false })
    } else {
      setExitsAccount({ show: false, disable: true })
    }
  }

  const closeInforSys = () => {
    setTimeout(() => {
      setInforSys(false)
    }, 3000) // chạy sau 3 giây
  }

  useEffect(() => {
    refetchListInvoice()
  }, [refetchListInvoice])

  useEffect(() => {
    getProfile()
    checkExistAccount()
  }, [])

  useEffect(() => {
    setFilterParams({
      q: debouncedSearch,
      page: 1,
    })
  }, [debouncedSearch, setFilterParams])

  return (
    <ContentContainer
      wrapperClassName="list-invoice"
      tabs={<InvoiceDashboard statistics={invoiceListData?.statistics} />}
    >
      <ContentContainer.Header
        titleContent={'Danh sách hoá đơn đầu vào'}
        toolBar={
          <Space>
            {(profile?.Organization?.isInput ??
              profile?.OrganizationDepartment?.isInput) && (
              <VIButton
                text={isSynchronizing ? `${t('Syncing')}...` : t('SyncNow')}
                className="btn-blue border-0 p-3"
                onClick={() => {
                  setModalChooseDateRangeSyncShowing(true)
                }}
                disabled={isSynchronizing}
              />
            )}
            {exitsAccount?.show && (
              <VIButton
                text={
                  exitsAccount?.disable
                    ? `Đang đăng ký dịch vụ`
                    : 'Đăng ký dịch vụ'
                }
                className="btn-blue border-0 p-3"
                style={{ padding: '8px' }}
                onClick={() => {
                  creataAccountService()
                }}
                disabled={exitsAccount?.disable}
              />
            )}
            <VIButton
              text={t('DownloadList')}
              className=""
              style={{ padding: '8px' }}
              onClick={() => {
                // handleExportInvoices();
                // setShowModalInvoices(true);
                // quybka
                setModalInvoiceExportShowing(true)
              }}
              beforeIcon={<i className="fa-regular fa-download"></i>}
            />
            <AppDnD
              defaultColumns={defaultColumns}
              localStorageName={PreferenceKeys.savedColumnsInputInvoice_tt}
            />
          </Space>
        }
      >
        <Space
          wrap
          // className={Utils.cn(selectedInvoices.length > 0 ? 'd-none' : '')}
        >
          {' '}
          <CustomAntInput
            type="search"
            borderRadius="sm"
            width={150}
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
            }}
          />
          <FilterPopover
            menuPosition="bottomLeft"
            defaultValues={defaultValues}
            savedKey={'gFiltersInputInvoice'}
            onApply={setFilterParams}
            // onchangeDate={onchangeDate}
            notViewAll={1}
          />
        </Space>
      </ContentContainer.Header>
      <ContentContainer.Body>
        <CustomDataTable
          columns={dynamicColumns}
          dataSource={invoiceListData?.tableData}
          isLoading={isGettingListData || isRefetching}
          isClickable
          handleDoubleClickRow={(row) => {
            // viewPdfInvoice(row)
            setModalViewPDF(true)
            setDataActive(row)
          }}
          pagination={{
            total: invoiceListData?.total,
            rowsPerPage: filterParams.limit,
            currentPage: filterParams.page,
            onChangePage: (page) => {
              setFilterParams({
                page,
              })
            },
            onChangeRowsPerPage: (limit) => {
              setFilterParams({
                limit,
                page: 1,
              })
            },
          }}
          // isSelectable
          selectedRows={{
            clearSelectedRows: toggledClearRows,
            handleSelectedRows: ({ selectedRows }) =>
              dispatch(setSelectedInvoices(selectedRows)),
            selectableRowSelected: (row) => _.includes(selectedInvoices, row),
          }}
        />
      </ContentContainer.Body>

      {/* modal choose date range sync */}
      <VIModal
        titleModal={t('SyncInvoice')}
        show={modalChooseDateRangeSyncShowing}
        contentModal={<ViewChooseDateRangeSync />}
        closeBtn
        handleSubmit={() => {
          // handleSyncAxion()
          setModalChooseDateRangeSyncShowing(false)
          console.log('Global.gFiltersAxionSync', Global.gFiltersAxionSync)
          synchronizationCQT(Global.gFiltersAxionSync)
        }}
        onHide={() => {
          setModalChooseDateRangeSyncShowing(false)
        }}
        buttonPositive={t('Sync')}
        buttonNegative={t('Cancel')}
      />

      {/* modal choose date range sync */}
      <VIModal
        titleModal={t('SyncInvoice')}
        show={inforSys}
        contentModal={
          <div>
            <div style={{ color: 'black', marginBottom: 13 }}>
              {t('SyncInvoiceText')}
            </div>
            <img
              src={AppResource.images.imgSyncInvoice}
              className="w-100"
              style={{}}
            />
          </div>
        }
        closeBtn
        onHide={() => {
          setInforSys(false)
        }}
        buttonNegative={t('Cancel')}
      />
      {/* modal view pdf*/}
      <VIModal
        modalSize="xl"
        titleModal={'Xem hóa đơn'}
        show={modalViewPDF}
        contentModal={
          <div style={{ height: '80vh' }}>
            <iframe
              src={
                ['v3.vietinvoice.vn', 'v2.vietinvoice.vn'].includes(
                  window.location.host,
                )
                  ? `https://ibot-dev.vietinvoice.vn/${dataActive?.previewPdfFile}`
                  : `https://ibot.vietinvoice.vn/${dataActive?.previewPdfFile}`
              }
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            ></iframe>
          </div>
        }
        closeBtn
        handleSubmit={() => {
          // handleSyncAxion()
          setModalViewPDF(false)
        }}
        onHide={() => {
          setModalViewPDF(false)
        }}
        // buttonPositive={t('Sync')}
        buttonNegative={t('Cancel')}
      />

      <VIModal
        titleModal={t('Export')}
        // modalSize="lg"
        show={modalInvoiceExportShowing}
        contentModal={
          <ViewInvoiceExport
            param={{
              q: debouncedSearch,
              ...filterParams,
              optimize: 1,
            }}
            onPressedCancel={() => {
              setModalInvoiceExportShowing(false)
            }}
          />
        }
        closeBtn
        handleSubmit={() => {}}
        onHide={() => {
          setModalInvoiceExportShowing(false)
        }}
      />
    </ContentContainer>
  )
}

export default ListInInvoice
